import { Button } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
const theme = localStorage.getItem("theme");

export const ContainedButton = ({
  children,
  type = "",
  onClick,
  size = "small",
  disabled = false,
  sx = {},
}) => {
  const { allColors, btncolor } = useSelector((state) => state);
  return (
    <Button
      type={type}
      variant="contained"
      size={size}
      //   fullWidth
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: btncolor,
        color:
          theme === "dark" ? allColors.fontColor : allColors.lightFontColor,

        "&:hover": { backgroundColor: btncolor },
        mx: 0.5,
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export const OutlinedButton = ({
  children,
  onClick,
  size = "small",
  disabled = false,
  type = "",
}) => {
  const { allColors, btncolor } = useSelector((state) => state);

  return (
    <Button
      type={type}
      variant="outlined"
      size={size}
      onClick={onClick}
      disabled={disabled}
      sx={{
        borderColor: btncolor,
        color:
          theme === "dark" ? allColors.fontColor : allColors.lightFontColor,
        mx: 0.5,
      }}
    >
      {children}
    </Button>
  );
};
